import { render } from "./NovncConsoleItem.vue?vue&type=template&id=571962f2&scoped=true"
import script from "./NovncConsoleItem.vue?vue&type=script&lang=js"
export * from "./NovncConsoleItem.vue?vue&type=script&lang=js"

import "./NovncConsoleItem.vue?vue&type=style&index=0&id=571962f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571962f2"]])

export default __exports__